import classNames from 'classnames'
import React from 'react'
import s from '../../fields.scss'
import {LabelProps} from './index'

export const Label = ({classes, dataHook, required, htmlFor, caption, tabIndex = -1}: LabelProps) => {
  return (
    <label className={classNames(s.caption, classes)} data-hook={dataHook} tabIndex={tabIndex} htmlFor={htmlFor}>
      {required && <span aria-hidden="true">*</span>}
      {caption}
    </label>
  )
}
